// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3y-gg","image":"Header_image__256Bz","name":"Header_name__ArGjj","info":"Header_info__3CA_P","infoRow":"Header_infoRow__V050q"};